import apiClient from "@/api/client";
import type { MaintenanceStatus, PlannedMaintenance, PlannedMaintenanceFormData } from "../types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

const maintenanceApi = {
  getStatus: () =>
    apiClient
      .get<{ data: MaintenanceStatus }>("/maintenance/status/")
      .then(wrap),

  list: () =>
    apiClient
      .get<{ data: PlannedMaintenance[] }>("/maintenance/")
      .then(wrap),

  get: (id: string) =>
    apiClient
      .get<{ data: PlannedMaintenance }>(`/maintenance/${id}/`)
      .then(wrap),

  create: (data: PlannedMaintenanceFormData) =>
    apiClient
      .post<{ data: PlannedMaintenance }>("/maintenance/", data)
      .then(wrap),

  update: (id: string, data: Partial<PlannedMaintenanceFormData>) =>
    apiClient
      .patch<{ data: PlannedMaintenance }>(`/maintenance/${id}/`, data)
      .then(wrap),

  remove: (id: string) => apiClient.delete(`/maintenance/${id}/`),

  end: (id: string) =>
    apiClient
      .post<{ data: PlannedMaintenance }>(`/maintenance/${id}/end/`)
      .then(wrap),

  extend: (id: string) =>
    apiClient
      .post<{ data: PlannedMaintenance }>(`/maintenance/${id}/extend/`)
      .then(wrap),
};

export default maintenanceApi;
